import { DataSender } from '../loaders'

const loadGoogleMapsApi = require('load-google-maps-api')

/**
* CityAutocomplete
*/

class CityAutocomplete {
    constructor(target, options) {

        loadGoogleMapsApi({'key': window.googleApiPublicKey, 'libraries': ['places']}).then(function (googleMaps) {
            var autocomplete = new googleMaps.places.Autocomplete(target[0], { types: ['(cities)'] });
            googleMaps.event.addListener(autocomplete, 'place_changed', function() {
            var place = autocomplete.getPlace();

            if(place.geometry === undefined) {
                return false;
            }

            var city = '';
            var country = '';
            var latitude = place.geometry.location.lat();
            var longitude = place.geometry.location.lng();
            var sublocality = '';

            $.each(place.address_components, function(key, value) {
                if ($.inArray('sublocality', value.types) >= 0) {
                    sublocality = value.long_name;
                }
                else if ($.inArray('locality', value.types) >= 0) {
                    city = value.long_name;
                }
                else if ($.inArray('country', value.types) >= 0) {
                    country = value.short_name;
                }
            });

            new DataSender({
                data: {
                    country: country,
                    city: city,
                    lat: latitude,
                    lng: longitude,
                    sublocality: sublocality
                },
                url: '/common/location-get-city/',

                success: function(data) {
                    if(data.status) {
                        if(options.blur) {
                            target.blur();
                        }

                        if(options.clear) {
                            target.val('');
                            target.blur(function() {
                                target.val('');
                            });
                        }

                        if(options.callback) {
                            options.callback(data.city);
                        }
                    }
                }
            });
            });
        });
    }
}
 export { CityAutocomplete }
